module.exports = __webpack_public_path__ + "static/media/294685.b4de7aaa.png";